import React from 'react'

import Features from '../components/Features'
import SEO from '../components/SEO'

const FeaturesPage: React.FC = () => (
  <>
    <SEO title="Features" />
    <Features />
  </>
)

export default FeaturesPage
